import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Card, Form} from 'react-bootstrap';
import { COLORS } from '../../theme';
import { Icon } from '../../components';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  &:hover:not(.disabled) {
    cursor: pointer;
    background-color: ${COLORS.lightGrey};
  }
  &.selected {
    border: 1px solid ${COLORS.primary};
  }
`;

const cardHeaderStyle = {
  textAlign: 'center',
  color: COLORS.primary
}

const cardBodyStyle = {
  padding: '0.75rem',
  textAlign: 'center',
  fontWeight: 800
}

const iconProps = {
  size: '4x'
}

export default function CardInput({value, onChange, icon, text, ...props}) {

  const handleClick = () => !props.disabled && onChange(!value)

  return (
    <StyledCard className={`${value ? 'selected' : ''} ${props.disabled ? 'disabled' : ''}`} onClick={handleClick} >
      {value && <Icon icon='checkCircle' size='2x' style={{
        position: 'absolute',
        right: '0.2em',
        top: '0.2em',
        color: COLORS.primary
      }} />}
      <Card.Header style={cardHeaderStyle}>
        <Icon icon={icon} {...iconProps} />
      </Card.Header>
      <Card.Body style={cardBodyStyle} >
        {text}
      </Card.Body>
    </StyledCard>
  )
}

CardInput.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.node,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}
